import axios from "axios";
import endpoints from "./endpoints";

const API = axios.create({
  baseURL: `${endpoints.serverBaseurl}/api/v1`,
});

export default API;
